import { gsap } from "gsap/all";

import * as PIXI from 'pixi.js-legacy';
import "pixi-spine";
import "pixi-particles";

//import screenfull from "screenfull";
//global.screenfull = screenfull;

import * as P3 from "p3";

gsap.install(global);
//gsap.registerPlugin(MotionPathPlugin);
gsap.defaults({ overwrite: false });

import Main from "./Main";

const entry = new Main(1024, 768);
entry.init();